/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_TranscriptionInputs */



/**
* | output |
* | --- |
* | "Batch Transcription" |
*
* @param {Batch_TranscriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_transcription = /** @type {((inputs?: Batch_TranscriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_TranscriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcription par lot")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stapeltranskription")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trascrizione in batch")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пакетная транскрипция")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transcripción por lotes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("批量转录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("バッチ転写")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैच प्रतिलेखन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Transcrição em lote")
	return /** @type {LocalizedString} */ ("Batch Transcription")
});